import { Toast } from "@newsela/angelou";

export const EVENT_TOAST_ERROR = {
  showIcon: true,
  statusColor: Toast.statusColor.danger,
  children: "Cannot send email",
};
